// @flow

import React, { useCallback } from 'react';
import styled from 'styled-components';
import { media } from '../../../styles/GlobalStyle';
import config from 'config/app.config';
import { Licenses } from 'types/common';
import { __ } from '../../../i18n/l10n';

// FR
import advertisementImage from '../../../assets/images/avertissement.png';
import under18Image from '../../../assets/images/under18.png';

// ES
import under18EsImage from '../../../assets/images/es/18.png';
import autoProhibitionImage from '../../../assets/images/es/autoprohibition.png';
import jugarBienImage from '../../../assets/images/es/jugarbien.png';
import { JuegoConResponsabilidad, NoHayJuego } from './common';
import { ForbiddenLogo, ResponsiblyLogo } from './FooterSpritesheet';
import { ResponsibleGamingUrl } from 'config/paths';

// DE
import dswvImage from '../../../assets/images/de/dswv.png';
import gglImage from '../../../assets/images/de/ggl.png';

const Container = styled.div`
  ${media.greaterThan('desktop')`
    display: none;
  `}
  margin-bottom: 1em;
`;

const Column = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Wrap = styled(Container)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  width: 80%;
  align-self: center;
`;

const Advertisement = styled.div``;

const Forbidden = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ForbiddenText = styled.div`
  margin-left: 1em;
`;

const Img40 = styled.img`
  height: 40px;
`;

const Img30 = styled.img`
  height: 30px;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.5em 1em;
`;

const MargedLogo = styled.div`
  margin-right: 0.7em;
  min-width: 34px;
  transform: scale(0.8);
`;

const InlineLogoText = styled.div`
  font-size: 0.9em;
  display: flex;
  align-items: center;
  align-self: flex-start;

  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};
`;

const ImageSizeDE = styled.img`
  height: 25px;
  margin-top: 3px;

  & + & {
    margin-left: 25px;
  }
`;

type FooterProps = {
  className?: string,
};

export const Footer = ({ className }: FooterProps) => {
  const redirectToResponsibleGaming = useCallback(() => {
    window.location.href = ResponsibleGamingUrl;
  }, []);

  switch (config.license) {
    case Licenses.ES:
      return (
        <>
          <Wrap className={className}>
            <TextContainer>
              <JuegoConResponsabilidad />
            </TextContainer>
            <TextContainer>
              <NoHayJuego />
            </TextContainer>
            <a href="https://www.dev.winamax.es/respecto-a-winamax_proteccion-de-los-jugadores_juego-responsable">
              <Img30 src={under18EsImage} />
            </a>
            <a
              href="http://www.ordenacionjuego.es/es/rgiaj"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img40 src={autoProhibitionImage} />
            </a>
            <a href="https://www.jugarbien.es/" target="_blank" rel="noopener noreferrer">
              <Img30 src={jugarBienImage} />
            </a>
          </Wrap>
        </>
      );
    case Licenses.DE:
      return (
        <>
          <Column className={className}>
            <InlineLogoText onClick={redirectToResponsibleGaming}>
              <MargedLogo as={ResponsiblyLogo} />
              {__('Responsible gaming')}
            </InlineLogoText>
            <InlineLogoText>
              <MargedLogo as={ForbiddenLogo} />
              {__('No minors')}
            </InlineLogoText>
            <InlineLogoText>
              <ImageSizeDE src={dswvImage} />
              <ImageSizeDE src={gglImage} />
            </InlineLogoText>
          </Column>
        </>
      );
    case Licenses.FR:
      return (
        <>
          <Column className={className}>
            <Forbidden>
              <Img40 src={under18Image} alt="Interdit aux mineurs" />
              <ForbiddenText>
                Les jeux d’argent et de hasard
                <br />
                sont interdits aux mineurs
              </ForbiddenText>
            </Forbidden>
            <Advertisement>
              <img src={advertisementImage} alt="Jouer comporte des risques" width="100%" />
            </Advertisement>
          </Column>
        </>
      );
    default:
      return null;
  }
};
